import {ChatStatus} from '../../copilot.enums';
import {ChatState} from '../../copilot.types';
import {PlanCollapseState} from '../../plan/plan.enums';

export default function chatState({
  chatId,
  isPlanModeEnabled,
}: {
  chatId: string;
  isPlanModeEnabled: boolean;
}): ChatState {
  return {
    id: chatId,
    isPlanModeEnabled,
    chatItems: [],
    modalWidget: null,
    blockingChatItemId: null,
    informationText: '',
    draftMessage: {
      text: '',
      fileIds: [],
    },
    plan: null,
    status: ChatStatus.Idle,
    isPlanModeToggleOn: false,
    planCollapseState: PlanCollapseState.Expanded,
    contextWindowUsage: 0,
  };
}
